module.exports = __webpack_public_path__ + "static/media/birlaGroupLogo.9020ebd4.svg";